import React, { useState } from "react";

const editorialStaff = [
  { id: 1, name: "Mariell Jake Eltagonde", position: "Editor-in-Chief", photo: "/images/hub1.png" },
  { id: 2, name: "Thyrone Glenn Gargao", position: "Associate Editor/Sports", photo: "/images/hub2.png" },
  { id: 3, name: "Mauilyn Khlaire Sakilan", position: "Managing Editor for Administration", photo: "/images/hub3.png" },
  { id: 4, name: "Leonard Benzal", position: "Managing Editor for Finance", photo: "/images/hub4.png" },
  { id: 5, name: "Joanna Rose Fideles", position: "Circulation Manager/Features Editor", photo: "/images/hub5.png" },
  { id: 6, name: "Kissandra Lee Catelo", position: "News Editor", photo: "/images/hub6.png" },
  { id: 7, name: "Trisha Shyr Bataan", position: "Opinion Editor", photo: "/images/hub7.png" },
  { id: 8, name: "Paul Kent Tejada", position: "Social Media Manager", photo: "/images/hub8.png" },
  { id: 9, name: "Dhanmark Lunop", position: "Sports Staff", photo: "/images/hub9.png" },
  { id: 10, name: "Nash Harvey Jornales", position: "Sports Staff", photo: "/images/hub10.png" },
  { id: 11, name: "Henard Elorde", position: "Senior Photojournalists", photo: "/images/hub11.png" },
  { id: 12, name: "Lance Marvey Ijapon ", position: "Senior Photojournalists", photo: "/images/hub12.png" },
  { id: 13, name: "Luigi Sarino", position: "Graphic Designer&Layout Artist", photo: "/images/hub13.png" },
  { id: 14, name: "Kurt Bernaldez", position: "Graphic Designer&Layout Artist", photo: "/images/hub14.png" },
];

const advisers = [
  { id: 15, name: "Vanissa Velarde, MAEd", position: "Adviser", photo: "/images/hub15.png" },
  { id: 16, name: "Geraldine Anduyan, MA", position: "Adviser", photo: "/images/hub16.png" },
];

const developers = [
  { id: 17, name: "Harold John S. Ambid", position: "Developer", photo: "/images/harold.jpg" },
  { id: 18, name: "Joanna Rose Fideles", position: "Developer", photo: "/images/joanna.jpg" },
  { id: 19, name: "James David Tiu", position: "Developer", photo: "/images/james.jpg" },
  { id: 20, name: "Martin Nexie Songkit", position: "Developer", photo: "/images/martin.jpg" },
  { id: 21, name: "Hannah L. Galido", position: "Developer", photo: "/images/hannah.png" },
];

export default function EditorialStaff() {
  const [modalImage, setModalImage] = useState(null);

  return (
    <div className="relative">

      {/* 🔥 Blurred Background */}
      <div
        className="
          fixed inset-0 
          bg-cover bg-center 
          blur-xl 
          opacity-60 
          -z-10
        "
        style={{
          backgroundImage: `url('/images/thehubg.jpg')`
        }}
      />

      {/* MAIN CONTENT */}
      <section className="relative max-w-7xl mx-auto px-4 py-12 z-10">

        {/* Fullscreen Modal */}
        {modalImage && (
          <div
            className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-50"
            onClick={() => setModalImage(null)}
          >
            <img src={modalImage} className="max-w-[90%] max-h-[90%] rounded-lg" />
            <button
              className="absolute top-6 right-6 text-white text-3xl font-bold"
              onClick={() => setModalImage(null)}
            >
              ✕
            </button>
          </div>
        )}

        <h2 className="text-4xl font-bold mb-10 text-center text-orange-600">
          Editorial Staff
        </h2>

        {/* Staff grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6 mb-16">
          {editorialStaff.map(({ id, name, position, photo }, index) => (
            <StaffCard
              key={id}
              name={name}
              position={position}
              photo={photo}
              delay={index * 100}
              openModal={() => setModalImage(photo)}
            />
          ))}
        </div>

        {/* Adviser section */}
        <h3 className="text-3xl font-semibold mb-8 text-center text-orange-600">
          Faculty Adviser
        </h3>

        <div className="flex justify-center gap-8 mb-24">
          {advisers.map(({ id, name, position, photo }) => (
            <StaffCard
              key={id}
              name={name}
              position={position}
              photo={photo}
              highlight
              openModal={() => setModalImage(photo)}
            />
          ))}
        </div>

        {/* Developers section */}
        <h3 className="text-3xl font-semibold mb-8 mt-12 text-center text-orange-600">
          Developers
        </h3>

        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-6 justify-items-center">
          {developers.map(({ id, name, position, photo }, index) => (
            <StaffCard
              key={id}
              name={name}
              position={position}
              photo={photo}
              delay={index * 100}
              openModal={() => setModalImage(photo)}
            />
          ))}
        </div>

      </section>
    </div>
  );
}

function StaffCard({ name, position, photo, highlight, delay = 0, openModal }) {
  return (
    <div
      style={{ animationDelay: `${delay}ms` }}
      className={`rounded-xl p-4 flex flex-col items-center text-center transition-all transform hover:scale-105 
        bg-gradient-to-br ${highlight ? "from-orange-200 to-orange-400" : "from-white to-gray-100"} 
        opacity-0 animate-slideUpFade`}
    >
      <div
        className="relative w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 mb-3 cursor-pointer"
        onClick={openModal}
      >
        <img
          src={photo}
          alt={name}
          loading="lazy"
          className="w-full h-full rounded-full object-cover border-4 border-orange-500 transition-transform duration-300 hover:rotate-3"
        />
        {highlight && (
          <span className="absolute -top-2 -right-2 bg-orange-500 text-white text-xs font-bold px-2 py-1 rounded-full">
            ⭐
          </span>
        )}
      </div>
      <h3 className="text-sm sm:text-base md:text-lg font-semibold text-gray-900">
        {name}
      </h3>
      <p className="text-xs sm:text-sm md:text-base text-indigo-700">
        {position}
      </p>
    </div>
  );
}
